export default __webpack_public_path__ + "static/media/Google_G_Logo.d521483e.svg";